import React from 'react';
import Footer from './components/footer';
import Header from './components/header';
import classnames from 'classnames';
// import LanguageTip from '../languageTip';
import GdprMessage from '@/bizComponents/gdprMessage';
import css from './index.less';
import classNames from 'classnames';
import BreadCrumbs, { BreadCrumbsRoute } from './components/breadCrumbs';
import { useHistory } from 'umi';

export interface Props {
  hideHeader?: boolean;
  fullWidth?: boolean;
  headerStyle?: React.CSSProperties;
  footerStyle?: React.CSSProperties;
  headerClassName?: string;
  mainClassName?: string;
  footerClassName?: string;
  children?: React.ReactNode;
  breadCrumbs?: BreadCrumbsRoute[];
}

export const PageContainer: React.FC<Props> = ({
  hideHeader,
  fullWidth,
  headerStyle,
  footerStyle,
  headerClassName,
  mainClassName,
  footerClassName,
  children,
  breadCrumbs,
}) => {
  const history = useHistory();
  const scrollRef = React.useRef<{ scroll: Element | null }>({
    scroll: null,
  });

  const [mainMinHeight, setMainMinHeight] = React.useState<
    number | undefined
  >();

  const mainStyle = React.useMemo<React.CSSProperties>(
    () => ({
      minHeight: mainMinHeight ? `${mainMinHeight}px` : undefined,
    }),
    [mainMinHeight],
  );

  React.useEffect(() => {
    if (!scrollRef.current.scroll) {
      scrollRef.current.scroll =
        document.scrollingElement || document.getElementsByTagName('html')[0];
    }
    if (scrollRef.current.scroll) {
      scrollRef.current.scroll.scrollTop = 0;
    }
    if (typeof window !== 'undefined') {
      const minHeight =
        window.innerHeight -
        (hideHeader ? 0 : 84) -
        (breadCrumbs?.length ? 38 : 0) -
        153;
      setMainMinHeight(minHeight);
    }
  }, [history.location.pathname]);

  return (
    <>
      {/*
        #3768 去掉中英文主动切换按钮
        https://zbanx.coding.net/p/zbanx-v2/requirements/issues/3768/detail
      */}
      {/*<LanguageTip />*/}
      {!hideHeader && (
        <Header className={headerClassName} style={headerStyle} />
      )}
      <BreadCrumbs routes={breadCrumbs} />
      <div
        id="page-main"
        className={classnames(mainClassName, {
          [css.mainFixedWidth]: !fullWidth,
        })}
        style={mainStyle}
      >
        {children}
      </div>
      <Footer className={footerClassName} style={footerStyle} />
      <GdprMessage />
    </>
  );
};

export default PageContainer;
